import { render } from "./App.vue?vue&type=template&id=86365d46&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=86365d46&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86365d46"]])

export default __exports__